export enum SelfPlanModalType {
    finGroups = "fin_groups",
    progressiveScale = "progressive_scale",
    sequentialScale = "sequential_scale",
    products = "products",
}

export interface SelfPlanModalPayload {
    [SelfPlanModalType.finGroups]: {
        title: string;
        finGroupDetails: string[];
    };

    [SelfPlanModalType.progressiveScale]: {
        title: string;

        currentPercent: number;
        progressive: { from: number; coefficient: number }[];
    };
    [SelfPlanModalType.sequentialScale]: {
        title: string;
        minComplete: number;
        maxComplete: number | null;
    };
    [SelfPlanModalType.products]: {
        title: string;
        barcodes: string[];
    };
}

export type SelfPlanModalState = {
    [K in SelfPlanModalType]: {
        type: K;
        payload: SelfPlanModalPayload[K];
    };
}[SelfPlanModalType];
